module.exports = __webpack_public_path__ + "static/media/backArrow.177abbc9.svg";